import { helpers } from 'veritone-redux-common';
const { createReducer } = helpers;

export const LOADING_WATCHLIST = 'mentions/query-watchlist-loading';
export const LOADED_WATCHLIST = 'mentions/query-watchlist-loaded';
export const QUERY_WATCHLIST = 'metions/query-watchlist';
export const QUERY_WATCHLIST_SAGA = 'metions/query-watchlist-saga';
export const CREATE_WATCHLIST = 'mentions/create-watchlist';
export const CREATE_WATCHLIST_SAGA = 'mentions/create-watchlist-saga';

const defaultState = {
    byId: {},
    byFolderId: {},
    allIds: []
}

const watchlistReducer = createReducer(defaultState, {
    [LOADING_WATCHLIST]: (state, action) => ({
        ...state,
        loading: true,
        loaded: false
    }),

    [LOADED_WATCHLIST]: (state, action) => ({
        ...state,
        loading: false,
        loaded: true
    }),

    [QUERY_WATCHLIST]: (state, action) => {
        const { watchlists } = action.payload;
        return watchlists.filter(watchlist => watchlist.folders.length === 1)
                         .reduce((acc, watchlist) => {
                            const { id, name="", folders } = watchlist;
                            const folderId = folders[0].id;
                            return {
                                byId: {
                                    ...acc.byId,
                                    [id]: { id, name }
                                },
                                allIds: [...acc.allIds, id],
                                byFolderId: {
                                    ...acc.byFolderId,
                                    [folderId]: acc.byFolderId[folderId] ? [...acc.byFolderId[folderId], id] : [id]
                                }
                            }
                         }, { byId: {}, allIds: [], byFolderId: {} })
    },

    [CREATE_WATCHLIST]: (state, action) => {
        const { watchlist: { id, name, folders } } = action.payload;
        const folderId = folders[0];
        return {
            ...state,
            byId: {
                ...state.byId,
                [id]: { id, name }
            },
            allIds: [ ...state.allIds, id ],
            byFolderId: { [folderId]: state.byFolderId[folderId] ? [...state.byFolderId[folderId], id]: [id]}
        }
    }
})

export const loadingWatchlist = () => ({
    type: LOADING_WATCHLIST
})

export const loadedWatchlist = () =>   ({
    type: LOADED_WATCHLIST
})

export const queryWatchlist = (watchlists) => ({
    type: QUERY_WATCHLIST,
    payload: { watchlists }
})

export const createWatchlist = (watchlist) => ({
    type: CREATE_WATCHLIST,
    payload: { watchlist }
})

export const queryWatchlistSaga = () => ({
    type: QUERY_WATCHLIST_SAGA
})

export const createWatchlistSaga = (data) => ({
    type: CREATE_WATCHLIST_SAGA,
    payload: {
        data
    }
})

export const getWatchlistById = (state) => state.mentions.watchlists.byId;
export const getWatchlistLoaded = state => state.mentions.watchlists.loaded;

export const getWatchlistByFolderId = (state) => folderId =>
    state.mentions.watchlists.byFolderId[folderId].map(
        watchlistId => state.watchlists.byId[watchlistId]
    );

export default watchlistReducer;